module.exports = __webpack_public_path__ + "static/media/mobile.05f37082.svg";